import { useState } from 'react';

export default function useLogosState({ generalData }) {
    const [logos, setLogos] = useState({
        sv: {
            bigLogo: { logoUrl: generalData?.logo_url_se, logoData: null },
            smallLogo: {
                logoUrl: generalData?.logo_thumb_url_se,
                logoData: null,
            },
            favicon: { logoUrl: generalData?.favicon_url_se, logoData: null },
            emailLogo: {
                logoUrl: generalData?.logo_email_url_se,
                logoData: null,
            },
        },
        no: {
            bigLogo: { logoUrl: generalData?.logo_url_no, logoData: null },
            smallLogo: {
                logoUrl: generalData?.logo_thumb_url_no,
                logoData: null,
            },
            favicon: { logoUrl: generalData?.favicon_url_no, logoData: null },
            emailLogo: {
                logoUrl: generalData?.logo_email_url_no,
                logoData: null,
            },
        },
        fi: {
            bigLogo: { logoUrl: generalData?.logo_url_fi, logoData: null },
            smallLogo: {
                logoUrl: generalData?.logo_thumb_url_fi,
                logoData: null,
            },
            favicon: { logoUrl: generalData?.favicon_url_fi, logoData: null },
            emailLogo: {
                logoUrl: generalData?.logo_email_url_fi,
                logoData: null,
            },
        },
        da: {
            bigLogo: { logoUrl: generalData?.logo_url_dk, logoData: null },
            smallLogo: {
                logoUrl: generalData?.logo_thumb_url_dk,
                logoData: null,
            },
            favicon: { logoUrl: generalData?.favicon_url_dk, logoData: null },
            emailLogo: {
                logoUrl: generalData?.logo_email_url_dk,
                logoData: null,
            },
        },
        is: {
            bigLogo: { logoUrl: generalData?.logo_url_is, logoData: null },
            smallLogo: {
                logoUrl: generalData?.logo_thumb_url_is,
                logoData: null,
            },
            favicon: { logoUrl: generalData?.favicon_url_is, logoData: null },
            emailLogo: {
                logoUrl: generalData?.logo_email_url_is,
                logoData: null,
            },
        },
    });
    const [logoErrors, setLogoErrors] = useState({
        sv: {
            bigLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            smallLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            faviconErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            emailLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
        },
        no: {
            bigLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            smallLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            faviconErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            emailLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
        },
        fi: {
            bigLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            smallLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            faviconErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            emailLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
        },
        da: {
            bigLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            smallLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            faviconErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            emailLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
        },
        is: {
            bigLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            smallLogoErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
            faviconErrors: {
                isWrongFileType: false,
                isFileOversized: false,
            },
        },
    });

    return [logos, logoErrors, setLogos, setLogoErrors];
}
